module.exports = __webpack_public_path__ + "static/media/bg-p.f3898ae2.png";